export const layout = {
	headerHeight: '48px',
	maxContentWidth: '1032px',
};

export type AppLayoutType = typeof layout;

export const colors = {
	blackText: '#000000',
	whiteBackground: '#FFFFFF',
	whiteText: '#FFFFFF',
	lightGrey: '#828282',
	darkGrey: '#4F4F4F',
	grey800: '#E9E9E9',
	grey700: '#DFDFDF',
	greyTitle: '#333',
	lightBlack: '#0C2D52',
	authorContainerBackground: '#F2F2F2',
	borderColor: '#E8E8E8',
	linkText: '#0060C3',
	paragraphText: '#636363',
	buttonTextColor: '#FFFFFF',
	redButtonBackground: '#D2152D',
	redButtonHoverBackground: '#E51731',
	blueButtonBackground: '#0080F6',
	blueButtonHoverBackground: '#0085FF',
	statusBarBackground: '#00A871',
	statusBarEmptyBackground: '#D1D1D1',
	checkmarkGreen: '#00A871',
	checkmarkRed: '#D2152D',
	borderBlue: '#234E78',
};

export type AppColorsType = typeof colors;

export const responsiveBreakPoints = {
	maxSmallPhone: '(max-width: 390px)',
	maxPhone: '(max-width: 480px)',
	maxTablet: '(max-width: 768px)',
	maxSmallDesktop: '(max-width: 992px)',
	maxDefaultDesktop: '(max-width: 1200px)',
	maxMediumDesktop: '(max-width: 1440px)',
};

export type AppBreakpointsType = typeof responsiveBreakPoints;

export const fontSizes = {
	// Hero Section
	heroHeading: '40px',
	heroMobileHeading: '28px',
	trustHeading: '36px',
	heroBoxHeading: '18px',
	cardHeading: '24px',
	cardHeadingMobile: '20px',
	buttonText: '20px',
	smallParagraph: '16px',
	normalParagraphMobile: '14px',
	font14: '14px',
	tinyParagraph: '12px',
	normalParagraph: '16px',
	largeParagraph: '18px',
};

export type AppFSType = typeof fontSizes;

export const lineHeights = {
	// Hero Section
	heroHeading: '130%',
	trustHeading: '40px',
	heroBoxHeading: '23.4px',
	smallParagraph: '21px',
	buttonText: '24px',
	tinyParagraph: '16px',
	cardHeading: '31.2px',
	normalParagraph: '24px',
};

export type AppLineHeightsType = typeof lineHeights;

export const spacings = {
	s4: '4px',
	s6: '6px',
	s8: '8px',
	s10: '10px',
	s12: '12px',
	s14: '14px',
	s16: '16px',
	s20: '20px',
	s24: '24px',
	s32: '32px',
	s34: '34px',
	s36: '36px',
	s38: '38px',
	s40: '40px',
};

export type AppSpacingType = typeof spacings;

export const fontWeights = {
	light: 300,
	normal: 400,
	medium: 500,
	semibold: 600,
	bold: 700,
	extrabold: 800,
};

export type AppFontWeightType = typeof fontWeights;
